import React from 'react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import { useLanguage } from '../context/LanguageContext';

const TermsOfServicePage = () => {
  const { t } = useLanguage();

  return (
    <div className="min-h-screen">
      <Header />
      
      <section className="py-16 md:py-24 bg-white">
        <div className="container mx-auto px-4 max-w-4xl">
          <h1 className="font-montserrat-bold text-3xl md:text-4xl text-[#0b004c] mb-8 text-center">
            {t('termsTitle')}
          </h1>
          
          <div className="prose prose-lg max-w-none font-montserrat text-[#6a6a6a]">
            <p className="mb-6">
              <strong>{t('lastUpdated')}</strong> {t('january2025')}
            </p>

            <h2 className="font-montserrat-bold text-xl text-[#0b004c] mt-8 mb-4">{t('termsAcceptTitle')}</h2>
            <p className="mb-4">
              {t('termsAcceptContent')}
            </p>

            <h2 className="font-montserrat-bold text-xl text-[#0b004c] mt-8 mb-4">{t('termsServicesTitle')}</h2>
            <p className="mb-4">
              {t('termsServicesContent')}
            </p>

            <h2 className="font-montserrat-bold text-xl text-[#0b004c] mt-8 mb-4">{t('termsIPTitle')}</h2>
            <p className="mb-4">
              {t('termsIPContent')}
            </p>

            <h2 className="font-montserrat-bold text-xl text-[#0b004c] mt-8 mb-4">{t('termsUserTitle')}</h2>
            <p className="mb-4">{t('termsUserIntro')}</p>
            <ul className="list-disc pl-6 mb-4 space-y-2">
              <li>{t('termsUser1')}</li>
              <li>{t('termsUser2')}</li>
              <li>{t('termsUser3')}</li>
              <li>{t('termsUser4')}</li>
            </ul>

            <h2 className="font-montserrat-bold text-xl text-[#0b004c] mt-8 mb-4">{t('termsPaymentTitle')}</h2>
            <p className="mb-4">
              {t('termsPaymentContent')}
            </p>

            <h2 className="font-montserrat-bold text-xl text-[#0b004c] mt-8 mb-4">{t('termsLiabilityTitle')}</h2>
            <p className="mb-4">
              {t('termsLiabilityContent')}
            </p>

            <h2 className="font-montserrat-bold text-xl text-[#0b004c] mt-8 mb-4">{t('termsTerminationTitle')}</h2>
            <p className="mb-4">
              {t('termsTerminationContent')}
            </p>

            <h2 className="font-montserrat-bold text-xl text-[#0b004c] mt-8 mb-4">{t('termsGoverningTitle')}</h2>
            <p className="mb-4">
              {t('termsGoverningContent')}
            </p>

            <h2 className="font-montserrat-bold text-xl text-[#0b004c] mt-8 mb-4">{t('termsContactTitle')}</h2>
            <p className="mb-4">
              {t('termsContactContent')}
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default TermsOfServicePage;
